import type { FaireProductEntity } from "../../entity_types/product";

export const p_6tvbqzfwkn: FaireProductEntity = {
  token: "p_6tvbqzfwkn",
  type: "product",
  name: "Funny Mother's Day Card - Without me......",
  brandToken: "b_vrnc945tth",
  brandName: "Little Miss PinkerBell",
  imageUrl:
    "https://cdn.faire.com/fastly/9faa4f0f22f4d177fe0ecfead223df24a94344ea8bc7c53ff11214f3575aa2b0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/39245ccf9396b05229cd00168fc30be1b4a43c38aa77b207cdaade265b928692.jpeg",
    "https://cdn.faire.com/fastly/bec52c1a2e5ed94d31f528bb8d2db02bec433d55fb5a194bb17d245d941caec5.jpeg",
  ],
  priceDollars: 3,
  description:
    'SPECIFICATIONS\nSingle 5 x 7" card with a 5.25 x 7.25 envelope\nEach card is printed on Premium Presentation Paper 44lb/165g/m, ensuring a high-quality print that looks and feels fantastic. \n\nAll artwork is copyright of Haley Roberts, LLC\n\n\n\n\n\n',
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:30.436Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
